import { apiClient } from './apiClient';

export interface ReplyToEmailSettingResponse {
    replyToEmail: string | null;
    defaultReplyToEmail: string | null;
}

export const replyToEmailService = {
    get: (): Promise<ReplyToEmailSettingResponse> =>
        apiClient.get<ReplyToEmailSettingResponse>('/company-settings/reply-to-email'),

    set: (replyToEmail: string | null): Promise<void> =>
        apiClient.put<void>('/company-settings/reply-to-email', { replyToEmail }),
};
